import script from "./Viewport3D.vue?vue&type=script&setup=true&lang=js"
export * from "./Viewport3D.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__